import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"margin-bottom":"1rem"} }
const _hoisted_4 = { for: "email" }
const _hoisted_5 = { for: "entity_type" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { for: "password" }
const _hoisted_11 = { for: "password_repeat" }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Select = _resolveComponent("Select")!
  const _component_LoginContainer = _resolveComponent("LoginContainer")!

  return (_openBlock(), _createBlock(_component_LoginContainer, { isLoading: _ctx.isLoading }, {
    default: _withCtx(() => [
      (_ctx.token == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.isReset)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.isCreate ? _ctx.$t('password_reset_view.view.config_text') : _ctx.$t('password_reset_view.view.reset_text')), 1),
                  _createVNode(_component_RouterLink, { to: {name: 'login'} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Button, {
                        label: _ctx.$t('password_reset_view.view.login_button'),
                        fluid: ""
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("form", {
                  key: 1,
                  onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submitAskReset && _ctx.submitAskReset(...args)))
                }, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.isCreate ? _ctx.$t('password_reset_view.view.information_text_create') : _ctx.$t('password_reset_view.view.information_text')), 1),
                  _createVNode(_component_FloatLabel, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputText, {
                        id: "email",
                        modelValue: _ctx.email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                        fluid: "",
                        type: "email",
                        required: ""
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('password_reset_view.view.email_label')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FloatLabel, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Select, {
                        id: "entity_type",
                        options: _ctx.entityTypeOptions,
                        optionLabel: _ctx.getEntityTypeLabel,
                        modelValue: _ctx.entityType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entityType) = $event)),
                        fluid: ""
                      }, null, 8, ["options", "optionLabel", "modelValue"]),
                      _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('password_reset_view.view.entity_type_label')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Button, {
                    label: _ctx.$route.params.create == '1' ? _ctx.$t('password_reset_view.view.create_button') : _ctx.$t('password_reset_view.view.reset_button'),
                    fluid: "",
                    type: "submit"
                  }, null, 8, ["label"]),
                  _createVNode(_component_RouterLink, { to: {name: 'login'} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Button, {
                        label: _ctx.$t('password_reset_view.view.cancel_button'),
                        fluid: "",
                        severity: "secondary",
                        style: {"margin-top":"1rem"}
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  })
                ], 32))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.tokenCheck)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_ctx.isUpdated)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('password_reset_view.view.password_updated_text')), 1),
                        _createVNode(_component_RouterLink, { to: {name: 'login'} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Button, {
                              label: _ctx.$t('password_reset_view.view.login_button'),
                              fluid: ""
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('password_reset_view.view.password_reset_text')), 1),
                        _createElementVNode("form", {
                          onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitUpdatePassword && _ctx.submitUpdatePassword(...args)))
                        }, [
                          _createVNode(_component_FloatLabel, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputText, {
                                id: "password",
                                fluid: "",
                                type: "password",
                                required: "",
                                modelValue: _ctx.password,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('password_reset_view.view.password_label')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FloatLabel, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_InputText, {
                                id: "password_repeat",
                                fluid: "",
                                type: "password",
                                required: "",
                                modelValue: _ctx.passwordRepeat,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.passwordRepeat) = $event)),
                                invalid: this.password != this.passwordRepeat
                              }, null, 8, ["modelValue", "invalid"]),
                              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('password_reset_view.view.password_repeat_label')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Button, {
                            label: _ctx.$route.params.create == '1' ? _ctx.$t('password_reset_view.view.create_button') : _ctx.$t('password_reset_view.view.reset_button'),
                            fluid: "",
                            type: "submit"
                          }, null, 8, ["label"])
                        ], 32)
                      ]))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t('password_reset_view.messages.errors.token_expired')), 1))
          ]))
    ]),
    _: 1
  }, 8, ["isLoading"]))
}